import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PayWithBlikResponse, PayWithRedirectResponse, PeuPayments } from '../models/peu-payment.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PeuPaymentService {

  constructor(private http: HttpClient) { }

  getPayment(id: string): Observable<PeuPayments> {
    return this.http.get<PeuPayments>(`${environment.ESP.BASE}${environment.ESP.PAYMENTS}/${id}`);
  }

  createPayment$(id: string): Observable<PayWithRedirectResponse> {
    return this.http.post<PayWithRedirectResponse>(
      `${environment.ESP.BASE}${environment.ESP.PAYMENTS}/${id}${environment.ESP.REDIRECT}`,
      {}
    );
  }

  getPaymentStatus(billId): Observable<PeuPayments> {
    return this.http.get<PeuPayments>(`${environment.ESP.BASE}${environment.ESP.BILLS}/${billId}`);
  }

  createBlikPayment$(id: any, payload): Observable<PayWithBlikResponse> {
    return this.http.post<PayWithBlikResponse>(
      `${environment.ESP.BASE}${environment.ESP.PAYMENTS}/${id}${environment.ESP.BLIK}`,
      payload
    );
  }
}
